import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NotificationService } from '@heidelberg/control-center-frontend-integration';
import {
    HdmuiNotification,
    HdmuiNotificationPriority,
    HdmuiNotificationsService,
    Notification,
} from '@heidelberg/hdmui-angular';
import { map, take } from 'rxjs';

export function provideNotificationsService(): HdmuiNotificationsService {
    const notificationService = inject(NotificationService);

    const notifications = toSignal(
        notificationService.notifications$.pipe(
            map((items) =>
                items.map((notification: Notification): HdmuiNotification => ({
                    id: notification.id,
                    orgId: notification.orgId,
                    eventId: notification.eventId,
                    timestamp: new Date(notification.timestamp).getTime(),
                    appName: notification.appName,
                    href: notification.href,
                    banner: notification.banner,
                    routerLink: notification.routerLink,
                    priority: notification.priority as unknown as HdmuiNotificationPriority,
                    title: notification.title,
                    body: notification.body,
                }))
            )
        ),
        { initialValue: [] }
    );

    return {
        notifications,
        dismissNotifications: (ids: string[]) => {
            ids.forEach((id) => notificationService.delete(id).pipe(take(1)).subscribe());
        },
        dismissAll: () => {
            notificationService.deleteAll().pipe(take(1)).subscribe();
        },
    };
}
